import Vue from 'vue'
import VueRouter from 'vue-router'
import Vuex from 'vuex'
import moment from 'moment'
import VueMoment from 'vue-moment'
import numeral from 'numeral'
import App from './App.vue'
import router from './router'
import store from './store'
import 'babel-polyfill'
import './plugins/vuetify'
import VueGtag from 'vue-gtag'
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
import VueCookies from 'vue-cookies'

Date.prototype.addDays = function(days) {
    var date = new Date(this.valueOf());
    date.setDate(date.getDate() + days);
    return date;
}

import './stylus/main.styl'

/**
 * Boot strapping and initialisation of global methods / filters etc
 */

Vue.use(Vuex);
Vue.use(VueRouter);
Vue.use(VueGtag, {
    config: {
        id: store.state.GOOGLE_ANALYTICS_ID
    }
}, router);
Vue.use(VueMoment, { moment });
Vue.use(VueLodash, { name: 'handbook-lodash', lodash: lodash });
Vue.use(VueCookies);

Vue.mixin({
    methods: {
        convertStateToStateAbbreviation: function (state) {
            let stateAbbrev = '';
            switch (state) {
                case 'New South Wales':
                    stateAbbrev = 'NSW';
                    break;
                case 'Victoria':
                    stateAbbrev = 'Vic'
                    break;
                case 'Queensland':
                    stateAbbrev = 'Qld'
                    break;
                case 'Western Australia':
                    stateAbbrev = 'WA'
                    break;
                case 'South Australia':
                    stateAbbrev = 'SA'
                    break;
                case 'Tasmania':
                    stateAbbrev = 'Tas'
                    break;
                case 'Australian Capital Territory':
                    stateAbbrev = 'ACT'
                    break;
                case 'Northern Territory':
                    stateAbbrev = 'NT'
                    break;
            }
            return stateAbbrev;
        },
        convertStateAbbreviationToState: function (stateAbbrev) {
            let state = '';
            switch (stateAbbrev.toUpperCase()) {
                case 'NSW':
                    state = 'New South Wales';
                    break;
                case 'VIC':
                    state = 'Victoria'
                    break;
                case 'QLD':
                    state = 'Queensland'
                    break;
                case 'WA':
                    state = 'Western Australia'
                    break;
                case 'SA':
                    state = 'South Australia'
                    break;
                case 'TAS':
                    state = 'Tasmania'
                    break;
                case 'ACT':
                    state = 'Australian Capital Territory'
                    break;
                case 'NT':
                    state = 'Northern Territory'
                    break;
            }
            return state;
        },
        formatDate(DATE, PREFIX, OUTPUTFORMAT, trimMonth, INPUTFORMAT) {
            if (!DATE) {
                return '';
            }
            let format = OUTPUTFORMAT || 'DD.MM.YYYY';
            let monthFormat = 'MM.YYYY';
            trimMonth = (trimMonth === undefined || trimMonth === null) ? true : trimMonth;
            if (trimMonth) {
                if (format.startsWith("DD")) {
                    monthFormat = format.substring(3, format.length - 1);
                } else if (format.endsWith('DD')) {
                    monthFormat = format.substring(0, format.length - 3);
                } else {
                    monthFormat = format.substring(0, format.indexOf('DD')) + format.substring(format.indexOf('DD') + 3, format.length)
                }
            }
            else {
                monthFormat = format;
            }

            if (!PREFIX) {
                PREFIX = '';
            }

            if (DATE.match(/1900-[0]1-[0]1/)) {
                DATE = ''
            } else if (DATE.match(/[0-9]{4}-[0]1-[0]1/) && trimMonth) {
                DATE = DATE.substring(0, 4)
            }

            if (DATE && DATE != 'undefined' && DATE != 'Undefined' && DATE != '1900-01-01' && DATE != '1900-01-1') {
                if (DATE.length <= 4) {
                    DATE = PREFIX + DATE;
                }
                else if (DATE.length <= 7) {
                    DATE = PREFIX + moment(DATE, INPUTFORMAT).format(monthFormat);
                } else {
                    DATE = PREFIX + moment(DATE, INPUTFORMAT).format(format);
                }
            } else {
                DATE = ''
            }
            return DATE
        },
        numberToOrdinal(number) {
            if (number <= 0) return number.ToString();

            switch (number % 100) {
                case 11:
                case 12:
                case 13:
                    return number + "th";
            }

            switch (number % 10) {
                case 1:
                    return number + "st";
                case 2:
                    return number + "nd";
                case 3:
                    return number + "rd";
                default:
                    return number + "th";
            }
        },
        // used particularly for odata queries
        replaceSpecialCharacters(attribute) {
        // replace the single quotes
            attribute = attribute.replace(/'/g, "''");

            attribute = attribute.replace(/"+"/g, "%2B");
            attribute = attribute.replace(/\//g, "%2F");
            attribute = attribute.replace(/"?"/g, "%3F");
            attribute = attribute.replace(/%/g, "%25");
            attribute = attribute.replace(/#/g, "%23");
            attribute = attribute.replace(/&/g, "%26");
            return attribute;
        },
        showError(){
            alert("Something went wrong! Please try again later.");
        }
    }
})

Vue.config.productionTip = false

Vue.filter('stringDateFormat', function (value) {
    if (value && value != 'undefined' && value != 'Undefined' 
    && value != '1900-01-01' 
    && value != '1900-01-01T00:00:00Z' 
    && value != '1900-01-1' 
    && value != '0001-01-01'
    && value != '0001-01-01T00:00:00Z') {
        var dateDMY = moment(String(value));
        if (dateDMY.isValid()){
            return dateDMY.format('DD.MM.YYYY');
        }
        else {
            var dateFormat =  moment(String(value), 'YYYY-DD-MM');
            if (dateFormat.isValid()){
                return dateFormat.format('DD.MM.YYYY');
            }
            else {
                return ''
            }
        }
    } else {
        return ''
    }
});

Vue.filter('truncate', function (value, from, count, ellipsis = false) {
    let truncatedText = value.substring(from, from + count);

    if (ellipsis && truncatedText.length < value.length) {
        truncatedText += '...';
    }

    return truncatedText;
});

Vue.filter('dateFromTo', function (DateFrom, DateTo) {
    // DateFrom, DateTo
    if (DateFrom && DateFrom != 'undefined' && DateFrom != 'Undefined' && DateFrom != '1900-01-01' && DateFrom != '1900-01-1') {
        DateFrom = ' from ' + moment(String(DateFrom)).format('DD.MM.YYYY')
    } else {
        DateFrom = ''
    }
    if (DateTo && DateTo != 'undefined' && DateTo != 'Undefined' && DateTo != '1900-01-01' && DateTo != '1900-01-1') {
        DateTo = ' to ' + moment(String(DateTo)).format('DD.MM.YYYY')
    } else {
        DateTo = ''
    }
    return DateFrom + DateTo
});


Vue.filter("formatNumber", function (value) {
    return numeral(value).format("0,0"); // displaying other groupings/separators is possible, look at the docs
});

Vue.filter("isBoolean", function (value) {
    if (value === null || value === undefined || value === '') {
        return '-';
    } else {
        return value ? 'Yes' : 'No';
    }
});

Vue.filter("CurrentCeased", function (value) {
    if (value === 'True') {
        return 'Current';
    } else if (value === 'False') {
        return 'Ceased';
    } else {
        return 'Unknown';
    }
});

Vue.filter('percentage', function (value, decimals) {
    if (!value) {
      value = 0
    }
  
    if (!decimals) {
      decimals = 2
    }
  
    value = value * 100
    value = Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals)
    value = value + '%'
    return value
  });

Vue.filter('commas', function (value) {
    return value.toLocaleString()
});

// Define the filter
Vue.filter('commaSeparated', function(value) {
    if (!Array.isArray(value)) {
      return value;
    }
  
    return value.join(', ');
  });

// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
    // This goes through the matched routes from last to first, finding the closest route with a title.
    // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
    const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

    // Find the nearest route element with meta tags.
    const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
    const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

    // If a route with a title was found, set the document (page) title to that value.
    if (nearestWithTitle) document.title = nearestWithTitle.meta.title;

    // Remove any stale meta tags from the document using the key attribute we set below.
    Array.from(document.querySelectorAll('[data-vue-router-controlled]')).forEach(el => el.parentNode.removeChild(el));

    // Skip rendering meta tags if there are none.
    if (!nearestWithMeta) return next();

    // Turn the meta tag definitions into actual elements in the head.
    nearestWithMeta.meta.metaTags.map(tagDef => {
        const tag = document.createElement('meta');

        Object.keys(tagDef).forEach(key => {
            tag.setAttribute(key, tagDef[key]);
        });

        // We use this to track which meta tags we create, so we don't interfere with other ones.
        tag.setAttribute('data-vue-router-controlled', '');

        return tag;
    })
        // Add the meta tags to the document head.
        .forEach(tag => document.head.appendChild(tag));

    next();
});

new Vue({
    render: h => h(App),
    router,
    store
}).$mount('#app');
